const redirect = () => {
  try {
    const currentOrigin = new URL(location.href).origin;
    const referrerOrigin = new URL(document.referrer).origin;

    if (currentOrigin === referrerOrigin) {
      location.href = document.referrer;

      return;
    }

    location.href = "/";
  } catch (error) {
    location.href = "/";
  }
};

export default redirect;
